import request from '@/utils/request'

// 获取积分统计数据
export function totalTask(params) {
  return request({
    url: 'Admin/Article/totalTask',
    method: 'get',
    params
  })
}
